<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import EmailsEditor from '@/pages/settings/emailsTab/Emails-editor.vue';
import columns from '@/pages/settings/emailsTab/columns';
import {
  TYPES,
  CREATE_NEW, COMMERCIAL_TYPES,
} from '@/pages/settings/emailsTab/constants';

const b = bem('emails-tab');
export default {
  components: {
    EmailsEditor,
  },
  data() {
    return {
      isShowEditor: false,
      selectedEmail: null,
      sections: [],
      templateName: '',
      framesCount: 2,
      frameIds: [null, null],
      emailName: '',
      editSubject: '',
      editIsReminder: false,
      editIsDefault: false,
      editType: TYPES[0],
      CREATE_NEW,
      forCustomerCategoryId: COMMERCIAL_TYPES[0],
      // Copy popup state
      showCopyPopup: false,
      copyEmailId: null,
      selectedCopyCategory: null,
    };
  },
  methods: {
    ...mapActions({
      getEmailsAction: 'emails/getEmails',
      createEmailAction: 'emails/createEmail',
      copyEmailAction: 'emails/copyEmail',
      changeEmailAction: 'emails/changeEmail',
      deleteEmailAction: 'emails/deleteEmail',
      getPreviewEmailAction: 'emails/getPreviewEmail',
      clearPreviewEmailAction: 'emails/clearPreviewEmail',
      sendPreviewEmailAction: 'emails/sendPreviewEmail',
      getTemplateCollectionsAction: 'collections/getCollections',
      getCompaniesAction: 'companies/getCompanies',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    setEditorStatus(editEmail) {
      const {
        templateStructure,
        name,
        subject,
        isReminder,
        type,
        isDefault,
      } = editEmail || {};
      const newType = TYPES.find(({ value, label }) => value === type || label === type);
      const { sections, frameList } = templateStructure || {};

      this.selectedEmail = editEmail || null;
      this.isShowEditor = true;
      this.error = null;
      this.sections = sections || [];
      this.emailName = name || '';
      this.editSubject = subject || '';
      this.editIsReminder = Boolean(isReminder);
      this.editIsDefault = Boolean(isDefault);
      this.editType = newType || TYPES[0];
      this.forCustomerCategoryId = COMMERCIAL_TYPES
        .find(({ value }) => value === editEmail?.forCustomerCategoryId);
      if (frameList && frameList.length) {
        this.frameIds = frameList;
        this.framesCount = frameList.length;
      }
    },
    clearEditStatus() {
      const [firstType] = TYPES;
      const [firstCommercialType] = COMMERCIAL_TYPES;
      this.selectedEmail = null;
      this.isShowEditor = false;
      this.emailName = '';
      this.editSubject = '';
      this.editIsReminder = false;
      this.editIsDefault = false;
      this.editType = firstType;
      this.forCustomerCategoryId = firstCommercialType;
    },
    onClickCopy(id, forCustomerCategoryId) {
      this.copyEmailAction({ id, forCustomerCategoryId });
    },
    openCopyPopup(id) {
      this.copyEmailId = id;
      this.selectedCopyCategory = null;
      this.showCopyPopup = true;
    },
    closeCopyPopup() {
      this.showCopyPopup = false;
      this.copyEmailId = null;
      this.selectedCopyCategory = null;
    },
    confirmCopy() {
      if (this.selectedCopyCategory && this.copyEmailId) {
        this.onClickCopy(this.copyEmailId, this.selectedCopyCategory);
        this.closeCopyPopup();
      }
    },
    onClickDelete(id) {
      this.deleteEmailAction(id);
    },
    updateToggle(name, value) {
      this[name] = value;
    },
    changeType(type) {
      this.editType = type;
    },
    changeText(name, value) {
      this[name] = value;
    },
    updateFrames(frameIds, framesCount) {
      this.frameIds = frameIds;
      this.framesCount = framesCount;
    },
    updateCommercialType(newValue) {
      const baseType = COMMERCIAL_TYPES.find(({ value }) => value === newValue);
      if (baseType) {
        this.forCustomerCategoryId = baseType;
      } else {
        const company = this.companies.find((c) => c.id + 2 === newValue);
        if (company) {
          this.forCustomerCategoryId = {
            value: company.id + 2,
            label: company.displayName,
            text: company.displayName,
          };
        }
      }
    },
  },
  mounted() {
    this.getEmailsAction();
    this.getTemplateCollectionsAction({ pageKey: 'photo_art' });
    this.getCompaniesAction({ limit: 1000, offset: 0 });
  },
  computed: {
    ...mapState({
      emails: (state) => state.emails.emails,
      companies: (state) => state.companies.companies,
    }),
    columns() {
      return columns(TYPES, this.companies);
    },
    categoryOptions() {
      const baseOptions = [
        { value: 1, label: 'Consumer' },
        { value: 2, label: 'Commercial' },
      ];
      const companyOptions = (this.companies || []).map((company) => ({
        value: company.id + 2,
        label: company.displayName,
      }));
      return [...baseOptions, ...companyOptions];
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div :class="b('emails-top-block', { hide: isShowEditor })">
      <a-button
        type="primary"
        html-type="button"
        @click="setEditorStatus()"
      >
        {{CREATE_NEW}}
      </a-button>
    </div>
    <a-table
      :class="b('table', { hide: isShowEditor })"
      :columns="columns"
      :dataSource="emails"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'actions'">
          <div :class="b('action-buttons')">
            <a-button
              type="primary"
              html-type="button"
              @click="() => openCopyPopup(record.id)"
            >
              Copy
            </a-button>
            <a-button
              type="primary"
              html-type="button"
              @click="() => {setEditorStatus(record)}"
            >
              Edit
            </a-button>
            <a-button
              v-if="record.type !== 'hardcode'"
              type="primary"
              html-type="button"
              danger
              @click="() => {onClickDelete(record.id)}"
            >
              Delete
            </a-button>
          </div>
        </template>
      </template>
    </a-table>
    <emails-editor
      v-if="isShowEditor"
      :selectedEmail="selectedEmail"
      :emailName="emailName"
      :editSubject="editSubject"
      :editType="editType"
      :editIsReminder="editIsReminder"
      :editIsDefault="editIsDefault"
      :frameIds="frameIds"
      :forCustomerCategoryId="forCustomerCategoryId"
      :updateCommercialType="updateCommercialType"
      :clearEditStatus="clearEditStatus"
      :updateToggle="updateToggle"
      :changeType="changeType"
      :changeText="changeText"
      :framesCount="framesCount"
      :updateFrames="updateFrames"
      :startSections="sections || []"
      :companies="companies"
    />
    <a-modal
      v-model:open="showCopyPopup"
      title="Copy Email Template"
      @ok="confirmCopy"
      @cancel="closeCopyPopup"
      :okButtonProps="{ disabled: !selectedCopyCategory }"
    >
      <div :class="b('copy-popup')">
        <p>Select target category for the copy:</p>
        <a-select
          v-model:value="selectedCopyCategory"
          placeholder="Select category"
          style="width: 100%"
          :options="categoryOptions"
        />
      </div>
    </a-modal>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
